export const GET_CURRENT_MONTH = "GET_CURRENT_MONTH"
export const GET_CURRENT_LEGACY_MONTH = "GET_CURRENT_LEGACY_MONTH"
export const CLOSE_MONTH = "CLOSE_MONTH"
export const CLOSE_LEGACY_MONTH = "CLOSE_LEGACY_MONTH"
export const OPEN_MONTH = "OPEN_MONTH"
export const OPEN_LEGACY_MONTH = "OPEN_LEGACY_MONTH"